import {LocalStorageConstants} from "@/services/localstorage/LocalStorageConstants";
import {Game} from "@/models/Game";
import {classToPlain, plainToClass} from "class-transformer";

class LocalStorageService {

    removeGame() {
        localStorage.removeItem(LocalStorageConstants.GAME_PATH);
    }

    isPresent() {
        return localStorage.getItem(LocalStorageConstants.GAME_PATH) !== null;
    }

    getGame(): Game {
        const gameString = localStorage.getItem(LocalStorageConstants.GAME_PATH);
        if (gameString != null) {
            return plainToClass(Game, JSON.parse(gameString));
        }
        return new Game();
    }

    setGame(game: Game) {
        localStorage.setItem(LocalStorageConstants.GAME_PATH, JSON.stringify(classToPlain(game)));
    }

}

export const localStorageService = new LocalStorageService();